export default "__VITE_ASSET__DG655E1v__"